
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import { PATHS } from '@/routes/routePaths';
import { useUserBusiness } from '@/hooks/useUserBusiness';
import { useToast } from '@/hooks/use-toast';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const businessId = searchParams.get('business_id');
  const { data: userBusiness, isLoading: businessLoading } = useUserBusiness();
  const { toast } = useToast();

  // Check if business is active and redirect if not
  useEffect(() => {
    if (!businessLoading && userBusiness && userBusiness.is_active === false) {
      toast({
        title: "Access Denied",
        description: "Subscription features are only available for active businesses.",
        variant: "destructive"
      });
      navigate(PATHS.ADMIN_MY_BUSINESS);
      return;
    }
  }, [userBusiness, businessLoading, navigate, toast]);

  return (
    <div className="container py-12 flex items-center justify-center min-h-[70vh]">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md"
      >
        <Card className="text-center">
          <CardHeader>
            <div className="flex justify-center mb-4">
              <AlertCircle className="h-16 w-16 text-amber-500" />
            </div>
            <CardTitle className="text-2xl">Subscription Cancelled</CardTitle>
            <CardDescription>
              Your subscription process was cancelled.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              No charges have been made. You can try again or choose a different subscription plan.
            </p>
          </CardContent>
          <CardFooter className="flex flex-col gap-2">
            <Button 
              onClick={() => navigate(PATHS.subscription(businessId))} 
              className="w-full"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Return to Subscription Page
            </Button>
            <Button 
              variant="outline" 
              onClick={() => navigate(PATHS.ADMIN_MY_BUSINESS)}
              className="w-full"
            >
              Go to My Business
            </Button>
          </CardFooter>
        </Card>
      </motion.div>
    </div>
  );
};

export default SubscriptionCancelPage;
